export const FORM_TITLES = {
  AP_TESTING: 'AP Testing Request',
  BATCH_REQUEST: 'Batch Request',
  CARRIER_RATE: 'Carrier Rate Request',
  GEO_MILEAGE: 'Geo Mileage Request',
  INVOICE_AUDIT_ANALYSIS: 'Invoice Audit Analysis Request',
  RATING_ANALYSIS: 'Custom Analysis Request',
  PULL_DATA_REQUEST: 'Shipment Retrieval Request',
  PULL_DATA_ANALYSIS_REQUEST: 'Shipment Retrieval & Analysis Request',
  PULL_AND_SEND_REQUEST: 'Shipment Retrieval & Send Request',
  RETRIEVAL: 'Retrieval Request',
} as const;
